import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      d: "M9 22h9.091C19.144 22 20 21.047 20 19.875V4.125C20 2.953 19.143 2 18.091 2h-9.09a1 1 0 1 0 0 2.002L17.978 4c.011.029.021.07.021.124v15.75c0 .055-.01.097-.021.125H9a1 1 0 1 0 0 2M4.284 11.293l3-3a.999.999 0 1 1 1.414 1.414L7.405 11H14a1 1 0 0 1 0 2H7.405l1.293 1.293a.999.999 0 1 1-1.414 1.414l-3-3A1 1 0 0 1 4 12a1 1 0 0 1 .284-.707"
    }, null, -1)
  ]))]))
}
export default { render: render }